import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../services/api';
import { useAuth } from '../contexts/AuthContext';
import './LoginPage.css';

const LoginPage = () => {
  const navigate = useNavigate();
  const { isAuthenticated, login } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showLocalLogin, setShowLocalLogin] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  useEffect(() => {
    // Si déjà authentifié, rediriger vers l'accueil
    if (isAuthenticated) {
      navigate('/');
    }
  }, [isAuthenticated, navigate]);

  const handleMicrosoftLogin = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await authAPI.getLoginUrl();
      // Rediriger vers Microsoft pour l'authentification
      window.location.href = response.data.authUrl;
    } catch (err) {
      console.error('Erreur lors de la connexion:', err);
      setError('Erreur lors de la connexion. Veuillez réessayer.');
      setLoading(false);
    }
  };

  const handleLocalLogin = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      setError(null);

      const response = await authAPI.localLogin(username, password);
      login(response.data.token);
      navigate('/');
    } catch (err) {
      console.error('Erreur lors de la connexion locale:', err);
      setError(err.response?.data?.error || 'Identifiants invalides');
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h1>Outil de Traduction</h1>
        <p className="login-subtitle">Cartes de Restauration</p>

        {error && (
          <div className="login-error">
            {error}
          </div>
        )}

        {!showLocalLogin ? (
          <>
            <button
              className="login-button"
              onClick={handleMicrosoftLogin}
              disabled={loading}
            >
              {loading ? 'Connexion en cours...' : 'Se connecter avec Microsoft 365'}
            </button>

            <p className="login-info">
              Utilisez vos identifiants Microsoft 365 pour accéder à l'application
            </p>

            <div className="login-divider">
              <span>ou</span>
            </div>

            <button
              className="login-button login-button-secondary"
              onClick={() => setShowLocalLogin(true)}
              disabled={loading}
            >
              Connexion locale (test)
            </button>
          </>
        ) : (
          <>
            <form onSubmit={handleLocalLogin} className="local-login-form">
              <div className="form-group">
                <label>Nom d'utilisateur</label>
                <input
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder="admin"
                  required
                  disabled={loading}
                />
              </div>

              <div className="form-group">
                <label>Mot de passe</label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••"
                  required
                  disabled={loading}
                />
              </div>

              <button
                type="submit"
                className="login-button"
                disabled={loading}
              >
                {loading ? 'Connexion en cours...' : 'Se connecter'}
              </button>
            </form>

            <button
              className="login-button login-button-secondary"
              onClick={() => setShowLocalLogin(false)}
              disabled={loading}
            >
              Retour à Microsoft 365
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default LoginPage;
